/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Not_Admitted_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo waited 20 minutes in the waiting room, but nobody let the notetaker in." |
*
* @param {Meeting_Notetaker_Issue_Not_Admitted_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_not_admitted_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Not_Admitted_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Not_Admitted_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo wachtte 20 minuten in de wachtruimte, maar niemand liet de notetaker binnen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo a attendu 20 minutes dans la salle d'attente, mais personne n'a laissé entrer le notetaker.")
	return /** @type {LocalizedString} */ ("Wundo waited 20 minutes in the waiting room, but nobody let the notetaker in.")
});